export default {"src":"/_next/static/media/icon_16.c3abbe71.svg","height":34,"width":34};